/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because CSS pixels do not correspond to a fixed physical size — pixel density varies by device. Calibrating against a credit card (a worldwide standard size) makes the ruler accurate to your specific screen.`)
};

const es_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque los píxeles CSS no corresponden a un tamaño físico fijo — la densidad de píxeles varía según el dispositivo. Calibrar con una tarjeta de crédito (un tamaño estándar mundial) hace que la regla sea precisa para tu pantalla concreta.`)
};

const de_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weil CSS-Pixel keiner festen physischen Größe entsprechen — die Pixeldichte variiert je nach Gerät. Die Kalibrierung anhand einer Kreditkarte (einer weltweit einheitlichen Größe) macht das Lineal für deinen konkreten Bildschirm präzise.`)
};

const nl_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat CSS-pixels niet overeenkomen met een vaste fysieke grootte — de pixeldichtheid verschilt per apparaat. Door te kalibreren met een bankpas (een wereldwijd standaardformaat) wordt de liniaal nauwkeurig voor jouw specifieke scherm.`)
};

const fr_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parce que les pixels CSS ne correspondent pas à une taille physique fixe — la densité de pixels varie selon l'appareil. Calibrer avec une carte bancaire (une taille standard mondiale) rend la règle précise pour votre écran spécifique.`)
};

const it_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i pixel CSS non corrispondono a una dimensione fisica fissa — la densità di pixel varia da dispositivo a dispositivo. Calibrare con una carta di credito (una misura standard in tutto il mondo) rende il righello preciso per il tuo schermo specifico.`)
};

const pt_br2_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque pixels de CSS não correspondem a um tamanho físico fixo — a densidade de pixels varia por aparelho. Calibrar com um cartão de crédito (um tamanho padrão mundial) deixa a régua precisa para a sua tela específica.`)
};

const pt_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque os pixels CSS não correspondem a um tamanho físico fixo — a densidade de pixels varia consoante o dispositivo. Calibrar com um cartão de crédito (um tamanho padrão mundial) torna a régua precisa para o seu ecrã específico.`)
};

const ja_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSSピクセルは固定の物理サイズに対応しておらず、端末によってピクセル密度が異なるためです。世界共通サイズのクレジットカードを基準に校正することで、お使いの画面に合わせた正確な定規になります。`)
};

const zh_ruler_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为 CSS 像素并不对应固定的物理尺寸——不同设备的像素密度各不相同。通过银行卡（全球统一标准尺寸）校准，可以让标尺精确匹配你的具体屏幕。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_a1", locale)
	if (locale === "en") return en_ruler_faq_a1(inputs)
	if (locale === "es") return es_ruler_faq_a1(inputs)
	if (locale === "de") return de_ruler_faq_a1(inputs)
	if (locale === "nl") return nl_ruler_faq_a1(inputs)
	if (locale === "fr") return fr_ruler_faq_a1(inputs)
	if (locale === "it") return it_ruler_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_a1(inputs)
	if (locale === "pt") return pt_ruler_faq_a1(inputs)
	if (locale === "ja") return ja_ruler_faq_a1(inputs)
	return zh_ruler_faq_a1(inputs)
};